import { defineComponent as _defineComponent } from 'vue'
import { vModelDynamic as _vModelDynamic, withModifiers as _withModifiers, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03387417"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "tw-flex tw-items-center" }
const _hoisted_3 = ["id", "type", "placeholder", "disabled"]

import { ref, watch, onMounted } from "vue";
import CloseBoxIcon from "../svgs/closeBoxIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'inputFilterModal',
  props: {
  hintText: {
    type: String,
    required: true,
  },
  value: {
    type: [Number, String],
    default: 0,
    validator: (val) =>
      typeof val === "number" || typeof val === "string" || val === null,
  },
  classText: {
    type: String,
    default: "tw-text-[#B7B7B7]",
  },
  classInput: {
    type: String,
    default: "tw-text-[11px] tw-font-medium",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  isInRange100: {
    type: Boolean,
    default: false,
  },
  idPercentInput: {
    type: String,
    default: "",
  },
  isShowButtonClear: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: "text",
  },
  inputProps: {
    type: Object,
    default: () => ({}),
  },
  isInvalid: {
    type: Boolean,
    default: false,
  },
  fixed: {
    type: Number,
    default: 1,
  },
},
  emits: [
  "update:modelValue",
  "focusout",
  "on:blur",
  "clearValue",
  "focus",
],
  setup(__props, { emit }) {

const props = __props;


// eslint-disable-next-line no-unused-vars


const inputRef: any = ref(null);
const mirror: any = ref(null);
const currentValue = ref(props.value || props.value === 0 ? props.value : "");

onMounted(() => {
  resizeInput();
});

watch(
  () => props.value,
  () => {
    currentValue.value = props.value || props.value === 0 ? props.value : "";
  },
);

watch(
  () => currentValue.value,
  () => {
    resizeInput();
  },
);

const clearData = () => {
  currentValue.value = "";
  emit("update:modelValue", "");
  emit("clearValue", "");
};

const isMoreThanTwoFixed = (value: string) => {
  const n = value.length;
  const index = value.indexOf(".");
  return index !== -1 && (index < n - props.fixed - 1 || props.fixed === 0);
};

const isCheckInRange100 = (value: string) => {
  const num = parseFloat(value);
  return num < 0 || num > 100;
};

const updateInput = (e) => {
  if (
    isNaN(e.target.value) ||
    (props.isInRange100 && isCheckInRange100(e.target.value)) ||
    isMoreThanTwoFixed(e.target.value)
  ) {
    currentValue.value = currentValue.value.toString().slice(0, -1);
    return;
  }
  emit("update:modelValue", e.target.value);
};

const resizeInput = () => {
  //   if (mirror.value && inputRef.value) {
  //     mirror.value.textContent = currentValue.value || "";
  //     inputRef.value.style.width = mirror.value.offsetWidth + 2 + "px";
  //   }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`tw-flex tw-gap-[15px] tw-items-center ${
      __props.disabled ? 'tw-pointer-events-none' : ''
    }`)
  }, [
    _createElementVNode("div", {
      id: __props.idPercentInput,
      class: _normalizeClass([
        'tw-flex tw-justify-between tw-items-center tw-cursor-text filter-modal-input',
        __props.isInvalid ? '!tw-border-[red]' : '',
        __props.classInput,
      ]),
      onClick: _cache[5] || (_cache[5] = ($event: any) => ((inputRef.value as any)?.focus()))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("input", _mergeProps({
          id: `${__props.idPercentInput}-input`,
          ref_key: "inputRef",
          ref: inputRef,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentValue).value = $event)),
          type: __props.type,
          placeholder: __props.hintText,
          class: [
            'tw-max-w-[68px] tw-min-w-[10px]',
            __props.classText,
            __props.isInRange100 ? '!tw-w-[20px]' : 'tw-w-full',
          ],
          disabled: __props.disabled
        }, __props.inputProps, {
          onInput: updateInput,
          onFocus: _cache[1] || (_cache[1] = ($event: any) => (emit('focus'))),
          onFocusout: _cache[2] || (_cache[2] = ($event: any) => (emit('focusout', currentValue.value))),
          onBlur: _cache[3] || (_cache[3] = ($event: any) => (emit('on:blur'))),
          onPaste: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
        }), null, 16, _hoisted_3), [
          [_vModelDynamic, currentValue.value]
        ]),
        _createElementVNode("span", {
          ref_key: "mirror",
          ref: mirror,
          class: "invisible absolute whitespace-pre"
        }, null, 512),
        (__props.hintText)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass([
            currentValue.value || currentValue.value?.toString() === '0' ? 'show' : '',
            __props.classText,
          ])
            }, "%", 2))
          : _createCommentVNode("", true)
      ]),
      (currentValue.value !== '' && __props.isShowButtonClear)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            id: "close-iten",
            type: "button",
            class: "tw-bg-transparent tw-border-none tw-outline-none",
            onClick: clearData
          }, [
            _createVNode(CloseBoxIcon, {
              size: 15,
              color: "#FFF",
              "color-x": "#DBDBDB"
            })
          ]))
        : _createCommentVNode("", true)
    ], 10, _hoisted_1)
  ], 2))
}
}

})